import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaffPerformanceRowVm } from '../../../../domain/corporate/staff-performance-row-vm';

@Component({
   selector: 'app-performance-hotel-staff-inline-drawer',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './performance-hotel-staff-inline-drawer.component.html',
   styleUrls: ['./performance-hotel-staff-inline-drawer.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class PerformanceHotelStaffInlineDrawerComponent {
   @Input() hotelName: string | null = null;
   @Input() rows: StaffPerformanceRowVm[] = [];

   completionRateText(r: StaffPerformanceRowVm): string {
      if (!r.claimed) return '--';
      return `${Math.round(r.completionRate)}%`;
   }

   avgDaysText(v: number | null): string {
      if (v === null || !Number.isFinite(v)) return '--';
      return (v as number).toFixed(2);
   }
}
